import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FolderOpen, Calendar, MessageSquare, Users, Newspaper } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    }, []);
    const items = [
        { k: "case_requests", l: "Case Requests", icon: FolderOpen },
        { k: "bookings", l: "Bookings", icon: Calendar },
        { k: "contact_messages", l: "Messages", icon: MessageSquare },
        { k: "users", l: "Union Accounts", icon: Users },
        { k: "blog_posts", l: "Journal Posts", icon: Newspaper },
    ];
    return (
        <div data-testid="admin-dashboard">
            <div className="label-tag">Overview</div>
            <h1 className="mt-3 font-display text-4xl md:text-5xl font-bold">Admin Console</h1>
            <p className="mt-3 text-white/60">A live snapshot of everything unions are sending your way.</p>
            <div className="mt-10 grid grid-cols-2 md:grid-cols-5 gap-4">
                {items.map((it) => (
                    <div key={it.k} className="p-6 bg-ink-900 border border-white/10 rounded-2xl" data-testid={`admin-stat-${it.k}`}>
                        <it.icon size={20} className="text-gold-500" />
                        <div className="mt-3 text-xs uppercase tracking-[0.2em] text-white/60">{it.l}</div>
                        <div className="mt-2 font-display text-3xl font-bold">{stats ? stats[it.k] : "—"}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
